import { render, staticRenderFns } from "./SubmissionCategories.vue?vue&type=template&id=4c3a992d&scoped=true&"
import script from "./SubmissionCategories.vue?vue&type=script&lang=js&"
export * from "./SubmissionCategories.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionCategories.vue?vue&type=style&index=0&id=4c3a992d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a992d",
  null
  
)

export default component.exports